import { AbstractControl, FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { DateOnly } from '../repositories';


export function setRequired(ctrl: FormControl, required: boolean): void {
	required ? ctrl.addValidators([Validators.required]) : ctrl.removeValidators([Validators.required]);
	ctrl.updateValueAndValidity({ emitEvent: false });
}

export function maxDateValidator(date: Date | DateOnly): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const max = control.value && new Date(control.value).getTime() > date.getTime();
		return max ? { maxDate: { value: control.value } } : null;
	};
}

export function minDateValidator(date: Date | DateOnly): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const min = control.value && new Date(control.value).getTime() < date.getTime();
		return min ? { minDate: { value: control.value } } : null;
	};
}